module.exports = "#define GLSLIFY 1\nvoid main() {\n  gl_Position = vec4(position, 1.0);\n}"